// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as XCircleDefault } from '../../../../../ui-v3/src/assets/icons/default/general/x-circle.svg?react';
import { ReactComponent as XCircleSolid } from '../../../../../ui-v3/src/assets/icons/solid/general/X-CIRCLE.svg?react';
import { createIcons } from '../../Icon';
const XCircleIcon = /* @__PURE__ */ createIcons('XCircle', {
    default: XCircleDefault,
    solid: XCircleSolid
});
XCircleIcon.supportedTypes = [
    'default',
    'solid'
];
XCircleIcon.category = 'general';
export default XCircleIcon;
